import ActivityLogScreen from './ActivityLogScreen';
export default ActivityLogScreen;
